export function isSomeError(value: unknown): value is Error {
	return (
		value instanceof Error ||
		value instanceof DOMException ||
		value instanceof AggregateError ||
		value instanceof EvalError ||
		value instanceof RangeError ||
		value instanceof ReferenceError ||
		value instanceof SyntaxError ||
		value instanceof TypeError ||
		value instanceof URIError
	);
}
